import React from "react"

const isBrowser = typeof window !== "undefined"

const storageTheme = isBrowser
  ? localStorage.getItem("foris_theme")
  : "theme-light"
const storageAccesibilitySize = isBrowser
  ? localStorage.getItem("accesibility_size")
  : 0
const theme = storageTheme || "theme-light"
const accesibilitySize = parseInt(storageAccesibilitySize) || 0

const LanguageContext = React.createContext({
  lang: "es",
  messages: {},
  urlPrefix: "",
  theme,
  accesibilitySize,
})

export default LanguageContext
